import React from 'react';
import './ForbiddenModal.css';

const ForbiddenModal = ({ isOpen, onClose, message }) => {
  if (!isOpen) return null;

  return (
    <div className="forbidden-modal-overlay">
      <div className="forbidden-modal">
        <div className="forbidden-modal-header">
          <h3>غير مسموح بالوصول</h3>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        <div className="forbidden-modal-body">
          <div className="forbidden-icon">🚫</div>
          <p>{message || 'ليس لديك صلاحية للوصول إلى هذه الصفحة'}</p>
        </div>
        <div className="forbidden-modal-footer">
          <button className="ok-btn" onClick={onClose}>موافق</button>
        </div>
      </div>
    </div>
  );
};

export default ForbiddenModal;